import React, { useEffect } from 'react'
import { sitemapService } from '../services/sitemapService'

export const SitemapXML: React.FC = () => {
  useEffect(() => {
    // Generate and serve sitemap XML
    const xml = sitemapService.generateSitemapXML()
    
    // Set content type and serve XML
    const blob = new Blob([xml], { type: 'application/xml' })
    const url = URL.createObjectURL(blob)
    
    // Replace current page content with XML
    document.open()
    document.write(xml)
    document.close()
    
    // Set proper content type header (this would normally be done server-side)
    if (typeof window !== 'undefined') {
      // For client-side, we can't set headers, but we can provide the XML content
      console.log('Sitemap XML generated:', xml)
    }
    
    return () => {
      URL.revokeObjectURL(url)
    }
  }, [])

  return (
    <div style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', padding: '20px' }}>
      Loading sitemap...
    </div>
  )
}

// Component to display sitemap in human-readable format
export const SitemapViewer: React.FC = () => {
  const sitemapData = sitemapService.getSitemapData()
  
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Sitemap</h1>
          
          <div className="space-y-4">
            {sitemapData.map((entry, index) => (
              <div key={index} className="border-b border-gray-200 pb-4">
                <div className="flex items-center justify-between">
                  <a 
                    href={entry.url}
                    className="text-blue-600 hover:text-blue-800 font-medium"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {entry.url}
                  </a>
                  <span className="text-sm text-gray-500">
                    Priority: {entry.priority}
                  </span>
                </div>
                <div className="text-sm text-gray-600 mt-1">
                  Last modified: {new Date(entry.lastModified).toLocaleDateString()}
                  <span className="ml-4">
                    Change frequency: {entry.changeFrequency}
                  </span>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-8 pt-8 border-t border-gray-200">
            <div className="flex space-x-4">
              <button
                onClick={() => sitemapService.downloadSitemap()}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Download XML
              </button>
              <button
                onClick={() => {
                  const xml = sitemapService.generateSitemapXML()
                  navigator.clipboard.writeText(xml)
                  alert('Sitemap XML copied to clipboard!')
                }}
                className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              >
                Copy XML
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}